import { configureStore } from '@reduxjs/toolkit'
import { withReduxConfigs } from 'utils'

import mapsReducer from './maps'
import uiReducer from './ui'
import workspaceReducer from './workspace'

import memberApi from '~workspace/services/member'
import workspaceApi from '../services/workspace'

import { mapInitialState } from './maps'
import { uiInitialState } from './ui'
import { workspaceInitialState } from './workspace'

const createStore = (initialState) => {
  return configureStore(
    withReduxConfigs({
      reducer: {
        workspace: workspaceReducer,
        maps: mapsReducer,
        ui: uiReducer,
        [workspaceApi.reducerPath]: workspaceApi.reducer,
        [memberApi.reducerPath]: memberApi.reducer
      },

      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([
          workspaceApi.middleware,
          memberApi.middleware
        ]),

      preloadedState: prepPreloadedState(initialState)
    })
  )
}

const prepPreloadedState = (initialState) => {
  return {
    maps: {
      ...mapInitialState,
      maps: initialState?.maps?.items,
      total: initialState?.maps?.total
    },
    workspace: {
      ...workspaceInitialState,
      workspace: initialState?.workspace
    },
    ui: {
      ...uiInitialState,
      href: initialState?.href
    }
  }
}

export { createStore }
